<template>
  <div>
    <div class="row mt-3">
      <div class="col">
        <div class="form-group">
          <label for="first_name">First Name:</label>
          <div class="d-flex">
            <input
              id="first_name"
              v-model="payment.first_name"
              type="text"
              class="form-control"
              placeholder=""
            >
          </div>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label for="billing_address">Address:</label>
          <input
            id="billing_address"
            v-model="payment.billing_address"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="first_name">Last Name:</label>
          <div class="d-flex">
            <input
              id="last_name"
              v-model="payment.last_name"
              type="text"
              class="form-control"
              placeholder=""
            >
          </div>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label for="address_2">Address 2:</label>
          <input
            id="address_2"
            v-model="payment.address_2"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="first_name">Email:</label>
          <div class="d-flex">
            <input
              id="email"
              v-model="payment.email"
              type="text"
              class="form-control"
              placeholder=""
            >
          </div>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label for="address_2">Phone:</label>
          <input
            id="phone"
            v-model="payment.phone"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="state">State:</label>
          <div class="d-flex">
            <input
              id="state"
              v-model="payment.state"
              type="text"
              class="form-control"
              placeholder=""
            >
          </div>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label for="city">City:</label>
          <input
            id="city"
            v-model="payment.city"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="zip">State:</label>
          <div class="d-flex">
            <input
              id="zip"
              v-model="payment.state"
              type="text"
              class="form-control"
              placeholder=""
            >
          </div>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label for="city">Country:</label>
          <input
            id="country"
            v-model="payment.country"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
    </div>


    <div class="form-group">
      <card-title>Paypal Email</card-title>
      <input
        id="paypalemail"
        v-model="payment.paypal_email"
        type="text"
        class="form-control mt-3"
        placeholder=""
      >
    </div>

    <div class="form-group text-center">
      <button
        class="btn btn-success btn-block pr-3 pl-3"
        @click="save"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
    import CardBox from "@/components/CardBox";
    import CardTitle from "@/components/CardTitle";

    export default {
        name: "BillingInfo",
        components: {CardTitle, CardBox},
        data: function () {
            return {
                tab: 'payment',
                payment: {}
            }
        },
        mounted: function () {
            this.load()
        },
        methods: {
            save: function () {
                let vm = this
                this.$http.post(this.$config.api + 'payment', this.payment).then(function () {
                    vm.$swal('Update successfully')
                })
            },
            load: function () {
                let vm = this
                this.$http.get(this.$config.api + 'payment').then(function (res) {
                    vm.payment = res.data
                })
            }

        }
    }
</script>

<style scoped>

</style>